module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0084.jpg?v=8c122eef";